
<app-additional-driver *ngIf="(showDriverPage === currentActiveDriverPage.additonalDriverClosed || 
showDriverPage === currentActiveDriverPage.additonalDriverOpend)"></app-additional-driver>
<app-driver-list *ngIf="showDriverPage === currentActiveDriverPage.additonalDriverList"></app-driver-list> 

